import ActionConfirmationModalContent, {
    ActionConfirmationModalContentProps,
} from '@/features/pos/components/OrderFinalization/parts/ActionConfirmationModal/parts/Content'
import Modal from '@/features/ui/components/Modal'
import { FC } from 'react'

const ActionConfirmationModal: FC<ActionConfirmationModalContentProps> = ({
    action,
    onConfirm,
    onCancel,
}) => {
    return (
        <Modal>
            <ActionConfirmationModalContent
                action={action}
                onConfirm={onConfirm}
                onCancel={onCancel}
            />
        </Modal>
    )
}

export default ActionConfirmationModal
